import { gql } from 'apollo-boost';
import { useIdsFromUrl } from 'core/hooks/useIdsFromUrl';
import React from 'react';
import { useAuth } from 'site/components/auth/AuthProvider';
import {
    GetPrivateProductDetailDataQuery,
    ProductFormPaymentStatusEnum,
    useGetPrivateProductDetailDataQuery,
} from 'site/graphql';
import AuthWindow from '../../auth/AuthWindow';
import useSubscriptions from '../../auth/hooks/useSubscriptions';
import PrivateProductDetail from './PrivateProductDetail';

gql`
    query GetPrivateProductDetailData($id: Int!, $filter: ProductFormListRequest) {
        purchasedProduct(id: $id) {
            id
            name
            shortDescription
            hasAnyPurchasedForm
            hasFeedback
            pictureId
            lecturers {
                id
                account {
                    id
                    firstName
                    lastName
                    pictureId
                }
            }
            inviteLink {
                id
                dateExpire
                date
                link
                orderId
                accountId
            }
            productForms(filter: $filter) {
                id
                title
                type
                subscriptionAccess
                order {
                    id
                    accessUntil
                }
                webinars {
                    id
                    date
                    title
                    hours
                    soonCause
                    description
                    syncState
                    myParticipation {
                        id
                        url
                    }
                    eventRecord {
                        id
                        link
                    }
                    materials {
                        id
                        link
                    }
                    lecturers {
                        id
                        account {
                            id
                            firstName
                            lastName
                            pictureId
                        }
                    }
                }
                seminars {
                    id
                    date
                    title
                    hours
                    description
                    eventRecord {
                        id
                        link
                    }
                    materials {
                        id
                        link
                    }
                    lecturers {
                        id
                        account {
                            id
                            firstName
                            lastName
                            pictureId
                        }
                    }
                }
                records {
                    id
                    title
                    hours
                    description
                    pictureId
                    link
                    date
                    isViewed
                }
                materials {
                    id
                    title
                    description
                    link
                    date
                }
                videoCourses {
                    id
                    title
                    hours
                    description
                    pictureId
                    link
                    isViewed
                }
                certificates {
                    id
                    name
                    state
                    myCertificate {
                        id
                        number
                    }
                }
            }
        }
    }
`;

const PrivateProductDetailContainer: React.FC = () => {
    const { productId } = useIdsFromUrl('productId');
    const {
        myAccount: { accessToFreeForms },
    } = useAuth();
    const { hasSubscriptionFreeCourses } = useSubscriptions();

    const { data, loading, error } = useGetPrivateProductDetailDataQuery({
        fetchPolicy: 'cache-and-network',
        variables: {
            id: productId,
            filter: {
                paymentStatus: ProductFormPaymentStatusEnum.Already,
            },
        },
    });

    const product = (data && data.purchasedProduct) || ({} as GetPrivateProductDetailDataQuery['purchasedProduct']);

    return (
        <PrivateProductDetail
            error={error}
            loading={loading}
            product={product}
            productId={productId}
            hasSubscription={Boolean(accessToFreeForms) || hasSubscriptionFreeCourses}
        />
    );
};

export default () => (
    <AuthWindow>
        <PrivateProductDetailContainer />
    </AuthWindow>
);
